import styled, { Button, Scale, StyledComponent } from '@se-admin/falcon';

export const ViewAllSalesButtonWrapper: StyledComponent<'a', {}, {}> = styled('a')`
  text-decoration: none;
  width: 100%;
`;

export const ViewAllSalesButton: StyledComponent<typeof Button, {}, {}> = styled(Button)`
  margin-right: auto;
  margin-left: auto;
  margin-bottom: ${Scale.xl};
`;
